// extracted by mini-css-extract-plugin
export var image = "kf_dj";